import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fileUrl = (storagePath) => `${API}/gallery/file/${storagePath}`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(e, fallback = "Something went wrong. Awoo?") {
  const detail = e?.response?.data?.detail;
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
      .filter(Boolean)
      .join(", ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return fallback;
}

export default api;
